import axios from 'axios';

class HandStrengthData {
    static async fetch () {
        const httpClient = axios.create()
        httpClient.defaults.timeout = 2000

        const response = await httpClient.get('/data/hand_rank.json')

        if('data' in response) {
            return HandStrengthData.transformData(response.data)
        } else {
            alert('Could get hand rank data... Please try again..')
            return null
        }
    }
        
    static transformData = (rawData) => {
        const len = Object.keys(rawData).length

        let resultList = []

        for(let i = 0; i < len; i++) {
            let newData = rawData[i]

            newData.odds_6p = Math.round(newData.odds_6p*10000, 2)/100
            newData.odds_9p = Math.round(newData.odds_9p*10000, 2)/100

            resultList.push(newData)
        }

        return resultList
    }
}

export default HandStrengthData;